import { EMAIL_SUCCESS_MESSAGE, REMOVE_MESSAGE } from '../actions/types';
import { emailInfo } from '../constants/emailInfo';
const initialState = {
    message: '',
    emailSent: false
};
const postcodeEmail = (state = initialState, action) => {
    switch (action.type) {
        case EMAIL_SUCCESS_MESSAGE:
            return {
                message: emailInfo.EMAIL_SUCCESS_TEXT,
                emailSent: true
            };

        case REMOVE_MESSAGE:
            return initialState;
        default:
            return state;
    }
};
export default postcodeEmail;
